<script setup>
import { inject, onBeforeMount, computed } from 'vue';
import { useProductsStore } from '@/app/stores/productsStore.js';
import ProductCardDetailRange from '@/app/components/product-card/product-card-detail-range.vue';
import ProductCardDetailNonRange from '@/app/components/product-card/product-card-detail-non-range.vue';
import ProductListingSystemToggle from '@/app/components/product-listing/product-listing-system-toggle.vue';

const config = inject('config');
const productsStore = useProductsStore();
const data = computed(() => productsStore.detailsData(config.productData));

onBeforeMount(() => {
  productsStore.setLocales();
  productsStore.system = config.defaultSystem;
  productsStore.manageSystemToggleDisplay(data.value);
});
</script>

<template>
  <div class="c-product-specification__background-wrapper">
    <div class="c-product-specification">
      <div class="c-product-specification__top">
        <h2 class="c-product-specification__heading">{{ config.title }}</h2>
        <ProductListingSystemToggle />
      </div>

      <dl class="c-product-card__details-list">
        <template v-for="dataPoint in data" :key="dataPoint.propertyId">
          <ProductCardDetailRange
            v-if="productsStore.hasRangeDetail(dataPoint)"
            :dataPoint="dataPoint"
          />
          <ProductCardDetailNonRange v-else :dataPoint="dataPoint" />
        </template>
      </dl>
    </div>
  </div>
</template>